import { render, staticRenderFns } from "./paint.vue?vue&type=template&id=4c90dc1c&scoped=true"
import script from "./paint.vue?vue&type=script&lang=js"
export * from "./paint.vue?vue&type=script&lang=js"
import style0 from "./paint.vue?vue&type=style&index=0&id=4c90dc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90dc1c",
  null
  
)

export default component.exports